import React, { useState } from "react";
import { useAsyncDebounce } from "react-table";
import { Icon, Input, InputGroup, InputLeftElement } from "@chakra-ui/react";
import { AiOutlineSearch } from "react-icons/ai";

import { Callback } from "utils/types";

interface Props {
  setFilter: Callback;
  filter: string;
}

const Search: React.FC<Props> = ({ setFilter, filter }: Props) => {
  const [value, setValue] = useState(filter);
  const onChange = useAsyncDebounce(
    value => setFilter(value || undefined),
    200
  );
  return (
    <InputGroup>
      <InputLeftElement width="3rem" justifyContent="center" height="100%">
        <Icon as={AiOutlineSearch} color="blue.500" />
      </InputLeftElement>
      <Input
        onChange={e => {
          setValue(e.target.value);
          onChange(e.target.value);
        }}
        value={value}
        placeholder="Search"
        size="md"
        fontWeight="semibold"
        pl="3rem"
        variant="dark"
        rounded="lg"
      />
    </InputGroup>
  );
};

export default Search;
